export const SagaActions = {
  // ---------Modal-----------------
  CLOSE_MODAL: "CLOSE_MODAL",

  // ---------User-----------------
  FETCH_PROFILE: "FETCH_PROFILE",

  // ---------log Acctions---------
  INFO: "INFO",
  ERROR: "ERROR",
  WARN: "WARN",
  ADD_NEW_UUID: "ADD_NEW_UUID",
  CLEAR_LOGS: "CLEAR_LOGS",
  ADD_USERID: "ADD_USERID",

  // ---------Plans-----------------
  GET_PLANS: "GET_PLANS",

  // ---------Clients-----------------
  ADD_CLIENTS_LIST: "ADD_CLIENTS_LIST",

  // ========================================================
};
